import { isIOS, isMacOs, isSafari } from "react-device-detect";
const { ClipboardItem } = window;

const isCopySupported = () => {
  return ClipboardItem && !isIOS && !(isMacOs && isSafari);
};

export default isCopySupported;
